<template>
<!--清洗消毒地图-->
<div class="container">
    <div id="map" class="map"></div>
    <div class="top">
        <!-- <a-button
        v-for="item in buttonList"
        size="large"
        @click="taggerCity(item)"
        :key="item.code"
        :type="activeCity === item.code ? 'primary' : 'default'"
      >
        {{ item.name + "【" + item.sum + "】" }}
      </a-button> -->
        <a-dropdown v-if="buttonList.length > 0">
            <a-menu slot="overlay" @click="selectCity">
                <a-menu-item v-for="item in buttonList" :key="item.code">
                    {{ item.name + "【" + item.sum + "】" }}
                </a-menu-item>
            </a-menu>
            <a-button style="margin-left: 8px" @click="e => e.preventDefault()"> {{ center + "【"+ sum + "】"}}
                <a-icon type="down" />
            </a-button>
        </a-dropdown>
        <a-select v-model="county" placeholder="请选择区县" @change="
              getData();
            ">
            <a-select-option v-for="county in countys" :key="county.code" :value="county.code">
                {{ county.name }}
            </a-select-option>
        </a-select>

        <a-button type="primary" @click="e =>getData()">
            <template #icon>
                <SearchOutlined /></template>
            搜索
        </a-button>
    </div>
    <div class="bottom">
        <div class="map-legend-item-box">
            <div class="map-legend-item">
                <img :src="mapIconError" alt="" />
                <span class="error">未清洗</span>
            </div>
            <div class="map-legend-item">
                <img :src="mapIconSuccess" alt="" />
                <span class="success">已清洗</span>
            </div>
            <div class="map-legend-item">
                <img :src="mapIconWarning" alt="" />
                <span class="warning">即将过期</span>
            </div>
            <div class="map-legend-item">
                <img :src="mapIconError" alt="" />
                <span class="error">已过期</span>
            </div>
        </div>
        <a-button v-for="item in filterList" size="large" @click="taggerStatus(item)" :key="item.id" :type="filterStatus === item.id ? 'primary' : 'default'">
            {{ item.title }}
        </a-button>
    </div>
</div>
</template>

<script>
import mapIconError from "./../../assets/img/map_icon_error.png";
import mapIconSuccess from "./../../assets/img/map_icon_success.png";
import mapIconWarning from "./../../assets/img/map_icon_warning.png";
export default {
    name: "disinfectMap",
    data() {
        return {
            center: "南昌",
            map: null,
            activeCity: "360100",
            buttonList: [],
            filterStatus: "-1",
            sum: 0,
            county: '',
            countys: [],
            countyData: [],
            filterList: [{
                    title: "全部",
                    id: "-1",
                },
                {
                    title: "未清洗",
                    id: "0",
                },
                {
                    title: "已清洗",
                    id: "3",
                },
                {
                    title: "即将过期",
                    id: "2",
                },
                {
                    title: "已过期",
                    id: "1",
                },
            ],
            mapIconWarning,
            mapIconSuccess,
            mapIconError,
        };
    },
    created() {
        this.getCountys();
    },
    mounted() {
        this.mapInit();
        this.getCity();

    },
    methods: {
        mapInit() {
            this.map = new window.BMapGL.Map("map");
            this.map.enableScrollWheelZoom(true);
            var scaleCtrl = new window.BMapGL.ScaleControl(); // 添加比例尺控件
            this.map.addControl(scaleCtrl);
            var zoomCtrl = new window.BMapGL.ZoomControl(); // 添加缩放控件
            this.map.addControl(zoomCtrl);
            var point = new BMapGL.Point(116.404, 39.915); // 创建点坐标
            this.map.centerAndZoom(point, 15);
        },
        selectCity(e) {
            console.log(e.key);
            this.activeCity = e.key;
            this.buttonList.forEach((item) => {
                if (e.key == item.code) {
                    this.center = item.name;
                    this.sum = item.sum;
                }
            })
            // this.center = e.key == 0 ? "南昌" : name;
            this.checkDepInfo();
            this.mapView = {};
            this.zoom = 12;
            this.getData();
        },
        taggerCity({
            code,
            name
        }) {
            console.log(code);
            this.activeCity = code;
            this.center = code == 0 ? "南昌" : name;
            this.checkDepInfo();
            this.mapView = {};
            this.zoom = 12;
            this.getData();
        },
        taggerStatus({
            id
        }) {
            this.filterStatus = id;
            this.getData();
        },
        getData() {
            this.loading = true;
            let query = {
                city: this.activeCity === "0" ? "" : this.activeCity,
                qxzt: this.filterStatus === "-1" ? "" : this.filterStatus,
                county: this.county,
            };
            this.$axios
                .get("report/testReportInfo/map/qxxdMaplist", {
                    params: query,
                })
                .then((res) => {
                    this.loading = false;
                    let {
                        list
                    } = res.data.result;
                    this.mapList = list;
                    setTimeout(() => {
                        this.addMarkerLay(list);
                    }, 1000);
                });
        },
        addMarkerLay(list) {
            this.map.clearOverlays(); // 清空地图
            let markers = [];
            let points = [];
            list.forEach((item) => {
                let point = new BMapGL.Point(item.lng, item.lat);
                points.push(point);
                let iconData = mapIconError;
                // 未处理
                if (item.qxzt === "0"|| item.qxzt === "1") {
                    iconData = mapIconError;
                }
                // 已处理
                if (item.qxzt === "3") {
                    iconData = mapIconSuccess;
                }
                // 即将过期，已过期
                if (item.qxzt === "2") {
                    iconData = mapIconWarning;
                }
                let icon = new BMapGL.Icon(iconData, new BMapGL.Size(25, 25), {
                    offset: new BMapGL.Size(10, 25), // 指定定位位置
                });
                let marker = new BMapGL.Marker(point, {
                    icon,
                });
                marker.customData = item;
                markers.push(marker);
                marker.addEventListener("click", (e) => {
                    let {
                        customData
                    } = e.target;
                    let opts = {
                        width: 0,
                        height: 0,
                        offset: new BMapGL.Size(0, -12.5),
                        enableMessage: false, // 设置允许信息窗发送短息
                    };
                    let infoWindow = new BMapGL.InfoWindow(``, opts); // 创建信息窗口对象
                    infoWindow.setContent(`
            <div class="windowinfo" style="font-size: 16px; padding: 10px">
              <div>
                <span style="font-weight: bold">单位名称:</span>
                <span>${customData.jddwmc}</span>
              </div>
              <div>
                <span style="font-weight: bold">经营地址:</span>
                <span>${customData.door}</span>
              </div>
              <div>
                <span style="font-weight: bold">清洗单位:</span>
                <span>${customData.jcdw || "无"}</span>
              </div>
              <div>
                <span style="font-weight: bold">最后清洗日期:</span>
                <span>${customData.bgsj || "无"}</span>
              </div>
            </div>
          `);
                    this.map.openInfoWindow(infoWindow, e.target.latLng);
                });
                this.map.addOverlay(marker);
            });
            if (markers[0]) {
                this.map.centerAndZoom(markers[0].getPosition(), 12); // 设置中心点坐标和地图级别
            }
            // this.setZoom(points);
        },
        getCity() {
            let that = this;
            this.$axios.get("report/testReportInfo/map/jzktCitySize").then((res) => {
                console.log(res);
                let result = res.data.result;
                let total = 0;
                this.buttonList = [];
                let departs = that.$store.state.departs;
                if (departs != null && departs != '' && departs[0].areaCodeShi != null) {
                    result.forEach((item, index) => {
                        if (item.code == departs[0].areaCodeShi) {
                            that.buttonList.push(item);
                            this.sum = item.sum;
                            that.taggerCity({
                                code: item.code,
                                name: item.name
                            });
                        }
                    });
                } else {
                    result.forEach((item, index) => {
                        if (result.length !== index + 1) {
                            total = total + item.sum * 1;
                            that.buttonList.push(item);
                        }
                    });
                    that.buttonList.unshift({
                        code: "0",
                        name: "全省",
                        sum: total,
                    });
                    if (that.buttonList.length > 1) {
                        that.sum = that.buttonList[1].sum;
                        that.taggerCity({
                            code: that.buttonList[1].code,
                            name: that.buttonList[1].name
                        });
                    }
                    that.getData();
                }
            });

        },
        getCountys() {
            let that = this;
            this.$axios.get("report/testReportInfo/getAreaInfo").then((res) => {
                console.log(res);
                if (res.data.success) {
                    //根据用户角色权限展示对应行政区划
                    let citylist = res.data.result.cityData;
                    that.countyData = res.data.result.countyData;
                    const deptInfo = that.$store.state.departs;
                    if (deptInfo != null && deptInfo != "") {
                        console.log(deptInfo);
                        let areaCodeShi = deptInfo[0].areaCodeShi;
                        let areaCodeXian = deptInfo[0].areaCodeXian;
                        if (
                            areaCodeXian != null &&
                            areaCodeXian != "" &&
                            that.countyData != null
                        ) {
                            //市全部禁止选择  区县禁止选择非areaCodeXian的
                            for (var i = 0; i < that.countyData[areaCodeShi].length; i++) {
                                var countyss = that.countyData[areaCodeShi][i];
                                var countyCode = countyss.code;
                                if (countyCode == areaCodeXian) {
                                    that.countys = [{
                                        code: countyss.code,
                                        name: countyss.name,
                                    }, ];
                                    that.county = countyCode;
                                    break;
                                }
                            }
                        } else {
                            that.countys = countyData[that.cityData[0].code];
                        }
                    } else if (that.activeCity != null && that.activeCity != "") {
                        that.countys = that.countyData[that.activeCity];
                        if (that.countys.length > 0) {
                            that.county = that.countys[0].code;
                        }
                    }
                }
            });
        },
        checkDepInfo() {
            let that = this;
            setTimeout(() => {
                const deptInfo = that.$store.state.departs;
                if (deptInfo != null && deptInfo != "") {
                    console.log(deptInfo);
                    let areaCodeShi = deptInfo[0].areaCodeShi;
                    let areaCodeXian = deptInfo[0].areaCodeXian;
                    if (
                        areaCodeXian != null &&
                        areaCodeXian != "" &&
                        that.countyData != null
                    ) {
                        //市全部禁止选择  区县禁止选择非areaCodeXian的
                        for (var i = 0; i < that.countyData[areaCodeShi].length; i++) {
                            var countyss = that.countyData[areaCodeShi][i];
                            var countyCode = countyss.code;
                            if (countyCode == areaCodeXian) {
                                that.countys = [{
                                    code: countyss.code,
                                    name: countyss.name,
                                }, ];
                                break;
                            }
                        }
                    } else if (that.activeCity != null && that.activeCity != "") {
                        that.countys = that.countyData[that.activeCity];
                    }
                } else if (that.activeCity != null && that.activeCity != "") {
                    that.countys = that.countyData[that.activeCity];
                }
                if (this.countys != null && this.countys.length > 0) {
                    this.county = this.countys[0].code;
                } else {
                    this.county = ""
                }
            }, 500);
        }
    },
};
</script>

<style lang="scss">
.container {
    display: flex;
    flex-direction: column;
    position: relative;
    height: 100%;
    overflow: hidden;

    .map {
        width: 100%;
        height: 100%;
        flex: 1;
    }
}

.top {
    background-color: transparent;
    position: absolute;
    top: 20px;
    left: 30px;
    font-size: 20px;
    z-index: 99;

    .ant-btn-lg {
        margin: 10px;
        z-index: 99;
    }

    .ant-select {
        width: 150px;
    }
}

.bottom {
    background-color: transparent;
    position: absolute;

    bottom: 20px;
    padding-left: 20px;

    .map-legend-item {
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
        font-weight: bolder;
    }

    img {
        width: 25px;
    }

    .map-legend-item-box {
        width: 110px;
        padding: 10px;
        border-radius: 3px;
        background-color: white;
    }

    .success {
        color: #19be6b;
    }

    .error {
        color: #ed4014;
    }

    .warning {
        color: #ff9900;
    }

    .ant-btn-lg {
        margin: 10px;
        z-index: 99;
    }
}
</style>
